// =============================================================================
// SIREPPAR - Texto de cierre del período de reempadronamiento
// =============================================================================
// UN SOLO LUGAR
// -------------
// El texto estaba duplicado palabra por palabra en las dos pantallas que lo
// muestran —la inicial y la de trámite cerrado— con la fecha escrita a mano en
// cada una. Corregir una y olvidarse de la otra era lo más probable que pasara,
// sobre todo cuando el período se reabra y se vuelva a cerrar con otra fecha.
//
// LA FECHA VIENE DE LA CONFIGURACIÓN, NO DEL CÓDIGO
// -------------------------------------------------
// `VITE_REEMPADRONAMIENTO_CIERRE` se declara en los archivos de entorno, igual
// que `VITE_REEMPADRONAMIENTO_HABILITADO` y `VITE_REEMPADRONAMIENTO_PUBLICO`, que
// gobiernan estas mismas dos pantallas.
//
// Eso es lo que mantiene el código IDÉNTICO en master y en develop, y no es un
// detalle: `LoginPage.tsx` divergió entre las dos ramas durante meses y daba
// conflicto en cada merge, hasta que las tarjetas pasaron a depender de flags.
// Volver a escribir una fecha distinta por rama reintroduciría exactamente ese
// problema. Ver la sección de `LoginPage.tsx` del CLAUDE.md.
//
// ES UNA FECHA YA FORMATEADA, NO UNA FECHA ISO
// --------------------------------------------
// El valor esperado es lo que se muestra, en formato DD/MM/AAAA. A propósito no es
// una fecha ISO que haya que parsear y formatear: el dato sólo se muestra, nunca se
// compara ni se ordena, y parsearlo traería el problema de zona horaria que ya
// apareció en otras pantallas (una fecha ISO sin hora se interpreta como UTC y en
// Argentina puede terminar mostrando el día anterior).
//
// La fecha vigente NO se escribe acá: vive en `.env.production`. Este archivo no
// contiene ninguna fecha a propósito.
//
// SI LA VARIABLE NO ESTÁ
// ----------------------
// La frase sale sin fecha, no con un hueco ni con `undefined`. Un cierre sin la
// fecha exacta sigue siendo cierto; un cierre con una fecha en blanco, no.
// =============================================================================

const CIERRE = (import.meta.env.VITE_REEMPADRONAMIENTO_CIERRE || '').trim();

export const TEXTO_CIERRE_REEMPADRONAMIENTO = CIERRE
  ? `El período de reempadronamiento ha concluido el ${CIERRE}.`
  : 'El período de reempadronamiento ha concluido.';
